import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { CloseSession, GetConsultsByDate, GetSessions, GetUsers } from '../../../store/actions'
import CancelIcon from '@mui/icons-material/Cancel'
import { isEmpty } from '../../../utils/functions'
import { useNavigate } from 'react-router-dom'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import moment from 'moment'

const ConsultUsuarios = () => {
    const navigate = useNavigate()
    const dispatch: Dispatch<any> = useDispatch()
    const { user, users, sessions, consults } = useSelector((state: any) => state)
    const [day, setDay] = useState(moment())

    useEffect(() => {
        if (isEmpty(user)) {
            navigate('/')
        }
        dispatch(GetUsers())
        dispatch(GetSessions())
        dispatch(GetConsultsByDate(day))
        // eslint-disable-next-line react-hooks/exhaustive-deps -- carga inicial
    }, [])

    const cerrarSesion = (sessionId: string) => {
        dispatch(CloseSession(sessionId))
    }

    //console.log(day)

    return (
        <div className="pb-20 bg-darkGreen min-h-height-main px-28">
            <p className="w-full py-5 italic font-bold text-center text-white mini:text-xl xl:text-4xl font-pacifico drop-shadow-lg">
                Control de Usuarios
            </p>
            <div className="flex flex-col w-full px-10 py-10 bg-white rounded-lg">
                <div className="flex justify-end w-full gap-10">
                    <div className="flex gap-1">
                        <button
                            className="text-white rounded-md bg-violetDark hover:scale-105"
                            onClick={() => setDay(day.subtract(1, 'days'))}
                        >
                            <KeyboardArrowLeftIcon />
                        </button>
                        <div className="px-5 py-1 border-2 rounded-md border-violetDark">
                            {day.format('DD-MM-YYYY')}
                        </div>
                        <button
                            className="text-white rounded-md bg-violetDark disabled:bg-slate-400 disabled:text-slate-200"
                            disabled={day.format('DD-MM-YYYY') === moment().format('DD-MM-YYYY')}
                            onClick={() => setDay(day.add(1, 'days'))}
                        >
                            <KeyboardArrowRightIcon />
                        </button>
                    </div>
                    <button className="px-5 py-1 text-white rounded-md bg-violetDark hover:scale-105">
                        Actualizar
                    </button>
                </div>
                {users?.map((element: any, index: number) => (
                    <div className="flex flex-col w-full" key={index}>
                        <table className="mt-10 shadow-none">
                            <thead className="">
                                <tr className="">
                                    <th className="border-2">USUARIO</th>
                                    <th className="border-2">TIRADAS TOTALES</th>
                                </tr>
                            </thead>
                            <tbody className="">
                                <tr className="">
                                    <td className="text-lg font-semibold border-2 font-montserrat">
                                        {element.username}
                                    </td>
                                    <td className="px-3 text-base border-2">{consults?.lenght}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="shadow-none">
                            <thead className="">
                                <tr className="">
                                    <th className="border-2 w-[11%]">FECHA Y HORA</th>
                                    <th className="border-2 w-[15%]">SESION</th>
                                    <th className="w-[25%] border-2">DISPOSITIVO</th>
                                    <th className="border-2">TOKEN</th>
                                    <th className="border-2">ACCION</th>
                                </tr>
                            </thead>
                            <tbody className="">
                                {sessions?.reverse().map((session: any, index: number) =>
                                    session.user.objectId === element.objectId ? (
                                        <tr className="" key={index}>
                                            <td className="px-3 text-base text-center border-2 whitespace-nowrap">
                                                {new Date(session.createdAt).toLocaleString()}
                                            </td>
                                            <td className="px-3 text-base border-2">{session.objectId}</td>
                                            <td className="px-3 text-base border-2">
                                                {session.installationId || 'Indefinido'}
                                            </td>
                                            <td className="px-3 text-base border-2">{session.sessionToken}</td>
                                            <td className="flex justify-center px-3 text-base border-2">
                                                <button
                                                    className="px-5 py-1 text-white duration-300 bg-red-500 rounded-md hover:scale-110 disabled:bg-slate-400 disabled:text-slate-200 disabled:scale-100"
                                                    onClick={() => cerrarSesion(session.objectId)}
                                                    disabled={session.sessionToken === user.sessionToken}
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <CancelIcon fontSize="small" />
                                                        Cerrar
                                                    </div>
                                                </button>
                                            </td>
                                        </tr>
                                    ) : null
                                )}
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ConsultUsuarios
